
 document.addEventListener("DOMContentLoaded", function() {
  // Select the Flickity section by its ID or class
  var flickitySection = document.querySelector("#product-grid");
  
  // Hide all Flickity featured cards initially by ensuring they have the 'hidden' class
  var flickityCards = flickitySection.querySelectorAll(".featured-li");
  
  // Remove 'hidden' class to fade in the cards after Flickity has initialized
  flickityCards.forEach(function(card) {
    card.classList.remove("hidden");
  });

  // Optional: Fallback in case Flickity takes longer to load
  setTimeout(function() {
    flickityCards.forEach(function(card) {
      card.classList.remove("hidden");
    });
  }, 3000); // Adjust timeout duration as needed
});